<template>
<!-- Notificações com Dropdown -->
<el-dropdown trigger="click">
    <el-badge :value="inprogress.length" class="notification">
        <span class="el-dropdown-link">
            <el-icon :size="24"><Clock /></el-icon>                    
        </span>
    </el-badge>
  <template #dropdown>
    <el-dropdown-menu class="notifications-dropdown">
      <template v-if="inprogress.length">
        <el-dropdown-item
          v-for="(task, index) in inprogress"
          :key="index"
          @click="viewData(task)"
        >          
          <div>
            {{ task.title }}
            <div>{{ task.timer }}</div>
          </div>
        </el-dropdown-item>
      </template>
      <template v-else>
        <el-dropdown-item>Sem tarefas</el-dropdown-item>
      </template>
    </el-dropdown-menu>
  </template>
</el-dropdown>
</template>
<script>
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from 'element-plus';
import { getTasksInProgress } from '@/services/taskService';

export default {
    components: {
        ElDropdown,
        ElDropdownItem,
        ElDropdownMenu
    },
    data() {
        return {
            inprogress: [],
        }
    },
    methods: {
        async getData() {            
            try {      
                const response = await getTasksInProgress();        
                this.inprogress = response.data;        
            } catch (error) {
                console.error(error);
                this.inprogress = [];
                this.$message.error('Erro ao carregar tarefas!');
            }
        },
        viewData(task) {            
            try {
                this.$router.push({
                    name: 'TaskDetails',
                    params: {
                    id: task.id,
                    slug: task.slug
                    }
                });
            } catch (error) {
                console.error('[ERROR AO CARREGAR TAREFAS EM ANDAMENTO] ', error);
                this.$message.error('Erro ao abrir tarefa!');
            }
        },
    },
    mounted() {
        this.getData();
    }
}
</script>
<style scoped>
.notification {
    cursor: pointer;
}
</style>